<template>
  <custom-page ref="page" :fixTitle="$t('message.SAFETY_SECTION')" :id="id"></custom-page>
</template>

<script>
import CustomPage from '@/views/dmp/custom-page.vue';

export default {
  name: 'MeetingSafety',
  components: { CustomPage },
  props: ["id"],
  beforeRouteEnter: function(to, from, next) {
    next(function(comp) {
      comp.$refs.page.refresh();
    });
  }
};
</script>
